<template>
  <div class="tab">
    <el-tabs
      type="border-card"
      v-model="activeName"
      @tab-remove="removeTab"
      @tab-click="selectTab"
    >
      <el-tab-pane
        v-for="item in arrTab"
        :key="item.taburl"
        :name="item.taburl"
        :closable="item.taburl == '/welcome' ? false : true"
      >
        <span slot="label"
          ><i :class="item.tabicon"></i> {{ item.tabtitle }}</span
        ></el-tab-pane
      >
    </el-tabs>
    <div class="tags-close-box">
      <el-dropdown @command="handleTags">
        <span class="el-icon-more"></span>
        <el-dropdown-menu size="small" slot="dropdown">
          <el-dropdown-item command="other">关闭其他</el-dropdown-item>
          <el-dropdown-item command="all">关闭所有</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import router from "../../router";

export default {
  data() {
    return {};
  },
  created: function () {
    // if(this.$store.getters.activeTabName !== router.currentRoute.path){
    //     this.$store.getters.arrTab.forEach(item=>{
    //         if(item.taburl === router.currentRoute.path){
    //             this.$store.dispatch('tab/setActiveName',router.currentRoute.path)
    //         }
    //     })
    // }
    const isExist = this.$store.getters.arrTab.some((item) => {
      return item.taburl === router.currentRoute.path;
    });
    if (isExist) {
      this.$store.dispatch("tab/setActiveName", router.currentRoute.path);
    }else{
        const tabList =  localStorage.getItem('tabs') ? JSON.parse(localStorage.getItem('tabs')) : [];
        console.log(tabList)
         const curItem = tabList.filter(item => {
            return item.taburl == router.currentRoute.path;
        })
        if(curItem.length){
 this.$store.dispatch("tab/addTab", curItem[0]);
        }
       
    }
  },
  computed: {
    ...mapState({
      //activeName: state => state.tab.activeName,
      arrTab: (state) => state.tab.arrTab,
    }),
    activeName: {
      get() {
        return this.$store.getters.activeTabName;
      },
      set(val) {
        this.$store.dispatch("tab/setActiveName", val);
      },
    },
  },
  methods: {
    removeTab(targetName) {
      let tabs = this.arrTab;
      let activeNameNow = this.activeName;
      if (activeNameNow === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.taburl === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeNameNow = nextTab.taburl;
              router.push({ path: activeNameNow.substr(1) });
              this.$store.dispatch("tab/setActiveName", activeNameNow);
            }
          }
        });
      }
      this.$store.dispatch("tab/removeTab", targetName);
    },
    selectTab(targetName) {
      var path = targetName.name.substr(1);
      if (path !== router.currentRoute.fullPath.substr(1)) {
        router.push({ path: path });
      }
    },
    handleTags(command) {
      command === "other" ? this.closeOther() : this.closeAll();
    },

    // 关闭全部标签
    closeAll() {
         if(this.$store.getters.arrTab.length>1){
             if(router.currentRoute.path=='/welcome'){
                this.$store.dispatch("tab/clearTab")
                // router.push({ path: '/welcome' })
            }else{
               this.$store.dispatch("tab/clearTab");
               router.push({ path: '/welcome' });
            }
              
         }
        
    },
    // 关闭其他标签
    closeOther() {
        if(this.$store.getters.arrTab.length>1){
            console.log(1111,router.currentRoute.path)
            // if(router.currentRoute.path=='/welcome'){{}
            //     this.$store.dispatch("tab/clearOtherTab",router.currentRoute.path);
            // }
            if(router.currentRoute.path=='/welcome'){
                this.$store.dispatch("tab/clearTab")
                // router.push({ path: '/welcome' })
            }else{
                this.$store.dispatch("tab/clearOtherTab",router.currentRoute.path)
            }
        }
        
    },
  },
};
</script>

<style scoped>
.tab {
  /* width: 100%; */
  overflow: hidden;
  background: #fff;
  padding-right: 50px;
  position: relative;
}

.el-tabs__content {
  padding: 0;
}
.el-tabs--border-card >>> .el-tabs__content {
  padding: 0;
}
.el-tabs__header {
  margin: 0;
}
.el-tabs--card >>> .el-tabs__header {
  margin: 0;
}
.el-tabs--border-card >>> .el-tabs__content {
  padding: 0;
}
.tags-close-box {
  position: absolute;
  right: 0;
  top: 0;
  box-sizing: border-box;
  padding-top: 1px;
  text-align: center;
  width: 50px;
  height: 100%;
  background: #fff;
  box-shadow: -3px 0 15px 3px rgba(0, 0, 0, 0.1);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>